import styled, { keyframes } from 'styled-components';
import { getColor } from 'utils';
import { hexToRgba } from 'theme';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const popIn = keyframes`
  from { opacity: 0; transform: translateY(0.5rem) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

export const DialogBackdrop = styled('div')`
  position: fixed;
  inset: 0;
  z-index: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => hexToRgba(getColor(props, 'black'), 0.6)};
  animation: ${fadeIn} 0.2s ease;
`;

export const DialogCard = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 90%;
  max-width: 26rem;
  padding: 2.5rem 2rem 2rem;
  text-align: center;
  border-radius: 0.75rem;
  background-color: ${props => getColor(props, 'primary')};
  box-shadow: 0 1rem 2.5rem ${props => hexToRgba(getColor(props, 'black'), 0.35)};
  animation: ${popIn} 0.2s ease;
`;

export const DialogIconWrap = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  margin-bottom: 0.5rem;
  border-radius: 50%;
  background-color: ${props => hexToRgba(getColor(props, 'accent'), 0.15)};
`;

export const DialogTitle = styled('h2')`
  margin: 0;
  font-size: 1.35rem;
  font-weight: 600;
  color: ${props => getColor(props, 'onPrimary')};
`;

export const DialogText = styled('p')`
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
  color: ${props => getColor(props, 'onPrimary')};
`;

export const ModelName = styled('span')`
  font-weight: 600;
  color: ${props => getColor(props, 'onPrimary')};
`;

export const DialogActions = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  margin-top: 1.25rem;
`;

export const DismissButton = styled('button')`
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 0.85rem;
  padding: 0.25rem;
  color: ${props => getColor(props, 'mediumGrey')};
  transition: color 0.2s ease;

  &:hover {
    color: ${props => getColor(props, 'onPrimary')};
  }
`;
